import { CommonModule } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { TabsModule } from 'primeng/tabs';
import { LeadTimelineComponent } from 'src/app/private/components/leads/lead-timeline/lead-timeline.component';
import { LeadService } from 'src/app/private/services/lead.service';
import { DocumentService } from 'src/app/private/services/micro-services/document.service';
import { FollowUpService } from 'src/app/private/services/micro-services/followup.service';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { LeadCommunicationService } from 'src/app/private/services/micro-services/leadCommunication.service';
import { MettingService } from 'src/app/private/services/micro-services/metting.service';
import { NoteService } from 'src/app/private/services/micro-services/note.service';
import { TaskService } from 'src/app/private/services/micro-services/task.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-lead-activity-tabs',
  imports: [CommonModule, TabsModule, LeadTimelineComponent],
  templateUrl: './lead-activity-tabs.component.html',
  styleUrl: './lead-activity-tabs.component.scss'
})
export class LeadActivityTabsComponent {

  loading = false;
  lead_id: any;
  leadNotes: any = [];
  leadTasks: any = [];
  leadFollowUps: any = [];
  leadActivity: any = [];
  leadEmailCommunication: any = [];
  leadCallCommunication: any = [];
  leadMeeting: any = [];
  leadDocuments: any = [];
  @Input() currentLeadId: any;

  @Input() editType: any;

  accessObject: any = {};

  constructor(
    private api: LeadService,
    private messageService: MessageService,
    private localStorage: LocalStorageService,
    private route: ActivatedRoute,
    private noteService: NoteService,
    private followUpService: FollowUpService,
    private leadActivityService: LeadActivityService,
    private taskService: TaskService,
    private leadCommunicationService: LeadCommunicationService,
    private mettingService: MettingService,
    private documentService: DocumentService
  ) {
    if (!this.currentLeadId) {
      this.lead_id = this.route.snapshot.paramMap.get('id');
    } else {
      this.lead_id = this.currentLeadId;
    }

    this.accessObject = this.localStorage.checkCRUDAccess('lead', 'manual');

    console.log("Access Object: ", this.accessObject.isMoveToRegistrationAccess);

  }

  ngOnInit() {

    if (!this.currentLeadId) {
      this.lead_id = this.route.snapshot.paramMap.get('id');
    } else {
      this.lead_id = this.currentLeadId;
    }

    this.getLeadActivity();

    setTimeout(() => {
      this.getLeadNote();
    }, 500)


    setTimeout(() => {
      this.getLeadFollowUps();
      this.getLeadTasks();
    }, 1500)


    setTimeout(() => {
      this.getCommunicationData();
      this.getLeadMeetingData();
    }, 2300)

    if (this.editType === 'registration' || this.editType === 'application' || this.editType === 'enrollment' || this.editType === 'admission') {
      this.getDocumentData();

      this.documentService.documents$.subscribe((documents) => {
        this.leadDocuments = documents;
      });
    }

    this.noteService.notes$.subscribe((notes) => {
      this.leadNotes = notes;
    });

    this.followUpService.followUps$.subscribe((followUps) => {
      this.leadFollowUps = followUps;
    });

    this.leadActivityService.leadActivity$.subscribe((leadActivity) => {
      this.leadActivity = leadActivity
    });

    this.taskService.tasks$.subscribe((tasks) => {
      this.leadTasks = tasks;
    });

    this.leadCommunicationService.emailCommunication$.subscribe((emailCommunication) => {
      this.leadEmailCommunication = emailCommunication;
    });

    this.leadCommunicationService.callCommunication$.subscribe((callCommunication) => {
      this.leadCallCommunication = callCommunication;
    });

    this.mettingService.meets$.subscribe((meetings) => {
      this.leadMeeting = meetings;
    });
  }

  getLeadNote() {
    this.loading = true;
    const payload = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "lead_id": this.lead_id
      }
    }
    this.api.getLeadNotes(payload).subscribe({
      next: data => {
        this.loading = false;
        this.leadNotes = data;

        this.leadNotes = this.leadNotes.map((note: any) => {
          return {
            name: note?.user?.fname + ' ' + note?.user?.lname,
            date: moment(note?.updatedAt).format('DD/MM/YYYY HH:mm'),
            desc: note?.note_name,
            id: note?.id,
            restData: note
          }
        })

        this.noteService.setTasks(this.leadNotes);
      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get notes' });
      }
    }
    )
  }

  getDocumentData() {
    this.loading = true;
    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "lead_id": this.lead_id
    }
    this.api.getLeadDocuments(payload).subscribe({
      next: data => {
        this.loading = false;
        this.leadDocuments = data;

        this.leadDocuments = this.leadDocuments.map((document: any) => {
          return {
            name: document?.document_category,
            date: moment(document?.updatedAt).format('DD/MM/YYYY HH:mm'),
            desc: '',
            id: document?.id,
            document_url: document?.document_url,
            document_type: 'document_preview',
            restData: document
          }
        })

        this.documentService.setDocuments(this.leadDocuments);
      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get documents' });
      }
    }
    )
  }

  getLeadTasks() {
    this.loading = true;
    const payload = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "lead_id": this.lead_id
      }
    }
    this.api.getLeadTasks(payload).subscribe({
      next: data => {
        this.loading = false;
        this.leadTasks = data;

        this.leadTasks = this.leadTasks.map((task: any) => {
          return {
            name: task?.user?.fname + ' ' + task?.user?.lname,
            date: moment(task?.updatedAt).format('DD/MM/YYYY HH:mm'),
            desc: task?.tasks_name,
            id: task?.id,
            restData: task
          }
        }
        )

        this.taskService.setTasks(this.leadTasks);

      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get tasks' });
      }
    }
    )
  }


  getLeadFollowUps() {
    this.loading = true;
    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "lead_id": this.lead_id
    }
    this.api.getLeadFollowUp(payload).subscribe({
      next: data => {
        this.loading = false;
        this.leadFollowUps = data;
        this.leadFollowUps = this.leadFollowUps.map((followUp: any) => {
          return {
            name: followUp?.user?.fname + ' ' + followUp?.user?.lname,
            date: moment(followUp?.createdAt).format('DD/MM/YYYY HH:mm'),
            desc: `${followUp?.followup_mode} - ${followUp?.next_followup_action} on ${moment(followUp?.followup_date).format('DD/MM/YYYY')}${followUp?.remarks ? ` Remarks: ${followUp.remarks}` : ''
              }`,

            id: followUp?.id,
            restData: followUp
          }
        }
        )
        this.followUpService.setFollowUpList(this.leadFollowUps);
        this.loading = false;
      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get followups' });
      }
    })
  }


  getCommunicationData() {
    this.loading = true;
    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "lead_id": this.lead_id
    }
    this.api.getLeadCommunicationLogs(payload).subscribe({
      next: data => {
        this.loading = false;

        this.leadEmailCommunication = data?.filter((activity: any) => activity.communication_type === 'email');
        this.leadCallCommunication = data?.filter((activity: any) => activity.communication_type === 'call');

        this.leadEmailCommunication = this.leadEmailCommunication.map((email: any) => {
          return {
            name: email?.user?.fname + ' ' + email?.user?.lname,
            date: moment(email?.date_of_communication).format('DD/MM/YYYY HH:mm'),
            desc: `Subject: ${email?.email_extra_details?.subject} - Note: ${email?.note}`,
            id: email?.id,
            restData: email
          }
        }
        )

        this.leadCallCommunication = this.leadCallCommunication.map((call: any) => {
          return {
            name: call?.user?.fname + ' ' + call?.user?.lname,
            date: moment(call?.date_of_communication).format('DD/MM/YYYY HH:mm'),
            desc: `Status: ${call?.status} - Call Duration: ${call?.call_extra_details?.callDuration} sec - Note: ${call?.note}`,
            id: call?.id,
            restData: call
          }
        }
        )

        this.leadCommunicationService.setCommunicationData(this.leadEmailCommunication, this.leadCallCommunication);
      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get communication data' });
      }
    }
    )
  }


  getLeadMeetingData() {
    this.loading = true;
    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "lead_id": this.lead_id
    }
    this.api.getLeadMeeting(payload).subscribe({

      next: data => {
        this.loading = false;
        this.leadMeeting = data;
        this.leadMeeting = this.leadMeeting.map((meeting: any) => {
          return {
            name: meeting?.user?.fname + ' ' + meeting?.user?.lname,
            date: moment(meeting?.updatedAt).format('DD/MM/YYYY HH:mm'),
            desc: `Meeting Title: ${meeting?.meeting_title} - Meeting Description: ${meeting?.meeting_desc} - Meeting Link: ${meeting?.meeting_link} - Meeting Date: ${meeting?.meeting_date} - Meeting Time: ${meeting?.meeting_time}`,
            id: meeting?.id,
            restData: meeting
          }
        }
        )
        this.mettingService.setMettings(this.leadMeeting);
      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get meeting data' });
      }
    }
    )
  }


  getLeadActivity() {
    this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
  }


}
